import script from "./compare-libraries.vue?vue&type=script&setup=true&lang=ts"
export * from "./compare-libraries.vue?vue&type=script&setup=true&lang=ts"

import "./compare-libraries.vue?vue&type=style&index=0&id=6575bd0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6575bd0c"]])

export default __exports__